import { useEffect, useState, type ReactNode } from "react";
import { Menu, X } from "lucide-react";

import { useIsDesktop } from "../lib/viewport";
import { Button } from "../ui/button";
import { Sheet, SheetClose, SheetContent, SheetTitle, SheetTrigger } from "../ui/sheet";

type MobileNavigationProps = {
  title: string;
  closeLabel: string;
  navigationKey: string;
  children: ReactNode;
};

export const MobileNavigation = ({ title, closeLabel, navigationKey, children }: MobileNavigationProps) => {
  const [open, setOpen] = useState(false);
  const isDesktop = useIsDesktop();

  useEffect(() => {
    setOpen(false);
  }, [navigationKey, isDesktop]);

  return (
    <Sheet open={open && !isDesktop} onOpenChange={setOpen}>
      <SheetTrigger asChild>
        <Button type="button" variant="ghost" size="icon" className="size-10 shrink-0 md:hidden" aria-label={title}>
          <Menu aria-hidden />
        </Button>
      </SheetTrigger>
      <SheetContent size="sm" aria-describedby={undefined} className="crane-ui-surface h-dvh gap-4 p-4">
        <div className="flex shrink-0 items-center justify-between gap-3">
          <SheetTitle>{title}</SheetTitle>
          <SheetClose asChild>
            <Button type="button" variant="ghost" size="icon" className="size-10 shrink-0" aria-label={closeLabel}>
              <X aria-hidden />
            </Button>
          </SheetClose>
        </div>
        <nav aria-label={title} className="flex min-h-0 flex-1 flex-col gap-2 overflow-y-auto">
          {children}
        </nav>
      </SheetContent>
    </Sheet>
  );
};
